import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@rtkwlf/pro-solid-svg-icons/faPaperPlane';
import { useTranslation } from 'react-i18next';
import { generatePath, Link as RouterLink } from 'react-router-dom';

import type { WhatsNewItem } from '@platform/client/features/feature-config';

import { IconButton } from '@packages/fenrir/components/icon-button';
import { Stack } from '@packages/fenrir/components/stack';
import { Tooltip } from '@packages/fenrir/components/tooltip';

import { type AppSwitchMenuItem, AppSwitchMenu } from './app-switch-menu';
import { NotificationsMenu } from './notifications-menu';
import { SettingsMenu } from './settings-menu';

export const ToolbarActions = ({
  appSwitchItems,
  whatsNew,
}: {
  appSwitchItems: AppSwitchMenuItem[];
  whatsNew: WhatsNewItem[];
}) => {
  const { t } = useTranslation('app', {
    keyPrefix: 'appBar',
  });

  return (
    <Stack direction="row" spacing={1 / 2}>
      {appSwitchItems.length > 0 && (
        <AppSwitchMenu menuItems={appSwitchItems} />
      )}
      {whatsNew.length && <NotificationsMenu whatsNew={whatsNew} />}
      <Tooltip title={t('contactArcticWolf')}>
        <IconButton
          component={RouterLink}
          size="small"
          to={generatePath('/resource-center/contact-concierge')}
        >
          <FontAwesomeIcon icon={faPaperPlane} />
        </IconButton>
      </Tooltip>
      <SettingsMenu />
    </Stack>
  );
};
